const ANNOUNCE_GW_MODAL = '#modal-announce-gw'

App.openAnnounceGwModal = function () {
    if ($(ANNOUNCE_GW_MODAL).length && !!window.location.href.match(/#modal-announce-gw/)) {
        $('#modal-announce-gw').modal('show')
    }
}
